const routes = {
  name: 'MySupervision',
  redirect: { name: 'SupervisionOngoing' },
  path: 'supervision',
  component: () => import('layouts/SupervisionLayout.vue'),
  children: [
    {
      name: 'SupervisionOngoing',
      path: 'ongoing',
      component: () => import('pages/supervision/SupervisionList.vue'),
      props: {
        query: {
          overallStatus: 'OPEN',
        },
      },
    },
    {
      name: 'SupervisionCompleted',
      path: 'completed',
      component: () => import('pages/supervision/SupervisionList.vue'),
      props: {
        query: {
          overallStatus: 'CLOSE',
        },
      },
    },
    {
      path: 'supervision_request',
      children: [
        {
          name: 'SupervisionRequest',
          path: '',
          component: () => import('pages/supervision/RequestList.vue'),
        },
      ],
    },
    {
      name: 'SupervisionRevision',
      path: 'revision',
      component: () => import('pages/supervision/RevisionList.vue'),
    },
    {
      name: 'SupervisionRevisionDetails',
      path: 'revision/:thesisId',
      component: () =>
        import('pages/supervision/SupervisionRevisionDetails.vue'),
    },
    {
      name: 'showSupervisionDetails',
      path: ':thesisId',
      component: () => import('pages/supervision/SupervisionDetails.vue'),
    },
  ],
};

export const supervisionRoutes = routes;
